import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { IPlace } from "models/place";

interface IAlertProps {
  showDelete: (place: IPlace) => void;
}

export const PlaceAlertContext = createContext<IAlertProps>({} as IAlertProps);

export const usePlaceAlertContext = () =>
  useContext<IAlertProps>(PlaceAlertContext);

interface IOpen {
  open: boolean;
  place: IPlace | null;
}

export function PlaceAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    place: null,
  });

  const showDelete = (place: IPlace) => setOpenDelete({ open: true, place });
  const handleCloseDelete = () => setOpenDelete({ open: false, place: null });

  return (
    <PlaceAlertContext.Provider value={{ showDelete }}>
      {openDelete.place && (
        <DeleteModal
          open={openDelete.open}
          place={openDelete.place}
          handleClose={handleCloseDelete}
        />
      )}
      {children}
    </PlaceAlertContext.Provider>
  );
}
